import { render, staticRenderFns } from "./ContainerTruckSale.vue?vue&type=template&id=4cdd3008"
import script from "./ContainerTruckSale.vue?vue&type=script&lang=js"
export * from "./ContainerTruckSale.vue?vue&type=script&lang=js"
import style0 from "./ContainerTruckSale.vue?vue&type=style&index=0&id=4cdd3008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports